module.exports = __webpack_public_path__ + "img/安全漏洞攻击模拟.605b4a3c.png";